
























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import BulkUpdateRequest from '@/models/BulkUpdateRequest';
import AvailabilityAdded from '@/components/dropdowns/AvailabilityAdded.vue';
import moment from 'moment';
import TrackingUtils from '@/utils/tracking';

@Component
export default class BoxRoomAvailable extends Vue {

  get dropdownRoomStatus() {
    return this.$store.state.dashboard.dropdownRoomStatus.show;
  }

  get partnerId() {
    return this.$store.state.partner.id;
  }

  get errorInput() {
    return (this.availability < 0 || this.availability > 99);
  }

  get isSaturday() {
    const dayOfWeek = moment(this.date).format('d');
    return dayOfWeek === '6';
  }

  get isMonday() {
    const dayOfWeek = moment(this.date).format('d');
    return dayOfWeek === '1';
  }
  @Prop({ required: true, default: 0 }) public readonly availabilityQty!: number;
  @Prop({ required: true }) public readonly roomId!: string;
  @Prop({ required: true }) public readonly date!: string;
  @Prop({ required: true }) public readonly disabled!: boolean;

  public isEditingAvailability: boolean = false;
  public availability: number|string = this.availabilityQty;
  public prevAvailability: number = this.availabilityQty;
  public isLoading: boolean = false;

  public showInput() {
    if (this.disabled) { return; }
    this.isEditingAvailability = true;
    setTimeout(() => {
      if (this.$refs.roomAvailableInput) {
        (this.$refs.roomAvailableInput as HTMLInputElement).select();
      }
    }, 100);
  }

  public async updateAvailability(event: Event) {
    if (event.type === 'blur') {
      if (this.errorInput || this.availability === this.prevAvailability || this.isLoading) {
        this.isEditingAvailability = false;
        return false;
      } else if (this.availability === this.prevAvailability) {
        this.cancelUpdate();
      } else {
        this.performUpdateAvailability();
      }
    } else {
      this.isEditingAvailability = false;
      if (this.$refs.roomAvailableInput) {
        (this.$refs.roomAvailableInput as HTMLInputElement).blur();
      }
    }
  }

  public async performUpdateAvailability() {
    const payload = new BulkUpdateRequest(this.$props.roomId, false);
    payload.startDate = this.date;
    payload.endDate = this.date;
    payload.availabilityQty = Number(this.availability);
    try {
      this.isLoading = true;
      await this.$store.dispatch('bulkUpdate', payload);
      this.$store.dispatch('addToast', {
        type: 'success',
        message: 'messages.success.calendarUpdateApplied',
        timeout: 3,
      });


      this.$gtm.trackEvent({
        event: 'availabilityPageRoomsAvailable',
        start_date: payload.startDate,
        end_date: payload.endDate,
        rooms_available: TrackingUtils.getAvailabilityRange(Number(this.availability)),
        partnerId: this.partnerId,
      });
    } catch (e) {
      console.error(e);
    } finally {
      this.isEditingAvailability = false;
      this.isLoading = false;
      this.prevAvailability = Number(this.availability);
    }
  }

  public cancelUpdate() {
    this.isEditingAvailability = false;
    this.availability = this.prevAvailability;
  }

  public trim(event: any) {
    if (event.keyCode !== 13 ) {
      if (isNaN(event.key)) {
        this.availability = this.prevAvailability;
        setTimeout(() => (this.$refs.roomAvailableInput as HTMLInputElement).select(), 100);
      }
      if (this.availability.toString().length > 2) {
        this.availability = this.availability.toString().slice(0, -1);
      }
    }
  }

  @Watch('availabilityQty')
  public onAvailabilityQtyChange(newValue: number, prevVal: number) {
    this.availability = newValue;
    if (prevVal === 0) {
      this.showAddedPopup();
    }
  }

  @Watch('isEditingAvailability', {immediate: true})
  public onEditing(newValue: number) {
    if (newValue && this.$dropdown.isShown) {
      this.$dropdown.hide();
    }
  }

  private showAddedPopup() {
    const wrapperEl = this.$refs.boxRoomAvailable as any;
    if (!wrapperEl) {
      return;
    }
    this.$dropdown.show({
      component: AvailabilityAdded,
      show: true,
      x: wrapperEl.offsetParent.offsetLeft + wrapperEl.offsetLeft + wrapperEl.offsetWidth / 2,
      y: wrapperEl.offsetParent.offsetTop + 90,
    });
    setTimeout(() => {
      this.$dropdown.hide();
    }, 2000);
  }
}
